import { Card } from "@mui/material";
import { CardContent } from "@mui/material";
import { CardMedia } from "@mui/material";
import { Typography } from "@mui/material";
import { Link, useHistory } from "react-router-dom";
// Fetches the City from URL query param (here : window.location.search is an in-built browser property that returns the query param from URL, example: http://localhost:8081/?city=bengaluru => window.location.search would return "?city=bengaluru")
// let city = await getCityFromURL(window.location.search);
function VideoCard({setVideoId ,video}) {
  const history = useHistory()
  const link = `/video/${video._id}`

  function handleClick() {
    console.log('Handling Click')
    setVideoId(video._id)
    history.push(link);
    
    // window.location.reload(); // force a reload of the page
    
  }

  return (
    <Link to={link}>
   <Card onClick={handleClick}  className="card">
    <CardMedia component="img" height="140" image={video.previewImage} />
    <CardContent>
       <Typography gutterBottom variant="h6" component="div">
        {video.title}
      </Typography>
      <Typography  gutterBottom variant="body2">
        {video.releaseDate}
      </Typography>
    </CardContent>
  </Card>
  </Link>
  )
}

export default VideoCard